export default {
  
  data() {
    return {
      showSearch: false,
    };
  },
  mounted() {
    //
  },
  methods: {
    closeSearch() {
      this.showSearch = false
    },
    
    isBlogSearchPage() {
      return this.$route.name.startsWith('blog-search');
    },

    handleSubmit() {
        let currentUrl = window.location.href.split('?')[0];
        currentUrl = currentUrl.split('#')[0];
        if (currentUrl[currentUrl.length - 1] === '/') {
            currentUrl = currentUrl.slice(0, -1);
        }
        const searchUrl = currentUrl.includes('search') ? currentUrl : this.localePath('/blog/search');
        if (this.query) {
          const newUrl = `${searchUrl}?q=${encodeURIComponent(this.query.trim())}`;
          window.location.href = newUrl;
        }
    },

    handleKeywordClicked(keyword) {
        this.query = keyword;
        this.handleSubmit();
    },

  },

  watch: {
    '$i18n.locale': {
      handler() {
        if (this.isBlogSearchPage()) {
          this.query = this.$route.query.q || '';
          this.handleSubmit();
        }
      },
    },
  },
}